<template>
  <a-form-model
    class="part form campaign"
    ref="campaignForm"
    :model="campaign"
    :rules="rules"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
    :submit="onSubmit"
  >
    <a-form-model-item label="Sender" prop="sender">
      <a-input v-model="campaign.sender" placeholder="Sender of the campaign" />
    </a-form-model-item>

    <a-form-model-item label="Recipients" prop="recipients_list">
      <a-select mode="multiple" v-model="campaign.recipients_list" default-value="all">
        <a-select-option value="all"> All Customers </a-select-option>
        <a-select-option value="english-customer"> English Customers</a-select-option>
        <a-select-option value="chinese-customer"> Chinese Customers </a-select-option>
        <a-select-option value="customers-3-months"> New Customers(3 Months) </a-select-option>
        <a-select-option value="customers-6-months"> New Customers(6 Months) </a-select-option>
        <a-select-option value="customers-12-months"> New Customers(12 Months) </a-select-option>
        <a-select-option value="old-customers"> Old Customers(>1 Year) </a-select-option>
      </a-select>
    </a-form-model-item>

    <a-form-model-item label="Campaign Title" prop="title">
      <a-input v-model="campaign.title" placeholder="Title of the campaign" />
    </a-form-model-item>

    <a-form-model-item label="Subtitle" prop="subtitle">
      <a-input v-model="campaign.subtitle" placeholder="Subtitle" />
    </a-form-model-item>

    <a-form-model-item label="Content" prop="content">
      <a-input v-model="campaign.content" type="textarea" :rows="15" placeholder="Campaign content(text)..." />
    </a-form-model-item>

    <a-form-model-item label="Template" prop="template">
      <a-select v-model="campaign.template" default-value="default">
        <a-select-option value="default"> Default </a-select-option>
        <a-select-option value="template1"> Template 1 </a-select-option>
        <a-select-option value="template2"> Template 2 </a-select-option>
        <a-select-option value="template3"> Template 3 </a-select-option>
      </a-select>
    </a-form-model-item>

    <a-form-model-item label="Scheduled Date" prop="scheduled">
      <a-date-picker
        v-model="campaign.scheduled"
        show-time
        type="date"
        placeholder="Pick a scheduled time"
        style="width: 100%"
      />
    </a-form-model-item>

    <!-- Notification Channels -->
    <a-form-model-item label="Notification Channels">
      <a-checkbox-group v-model="campaign.notification_channels">
        <a-checkbox value="email"> Email </a-checkbox>
        <a-checkbox value="sms"> SMS </a-checkbox>
      </a-checkbox-group>
    </a-form-model-item>

    <a-form-model-item label="Description" prop="description">
      <a-input v-model="campaign.description" type="textarea" :rows="10" placeholder="Campaign description..." />
    </a-form-model-item>

    <!-- actions -->
    <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button type="primary" @click="onSubmit"> Create </a-button>
      <a-button style="margin-left: 10px"> Cancel </a-button>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
const KEY = 'CREATE_CAMPAIGN'

export default {
  name: 'campaign-form',
  data() {
    return {
      campaign: {
        notification_channels: ['email'],
      },
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
      rules: {
        sender: [{ required: true, message: 'Please input campaign sender', trigger: 'blur' }],
        title: [
          { required: true, message: 'Please input campaign title', trigger: 'blur' },
          { min: 3, max: 30, message: 'Length should be 3 to 30', trigger: 'blur' },
        ],
        sender: [{ required: true, message: 'Please input campaign sender', trigger: 'blur' }],
        content: [{ required: true, message: 'Please type content', trigger: 'change' }],
        // description: [{ required: true, message: 'Please input campaign description', trigger: 'blur' }],
      },
    }
  },
  methods: {
    onSubmit() {
      this.$refs.campaignForm.validate((valid) => {
        if (valid) {
          this.$emit('submit', this.campaign)
        } else {
          console.log('campaign error submit!!')
          return false
        }
      })
    },
    resetForm() {
      this.$refs.campaignForm.resetFields()
    },
  },
  mounted() {},
}
</script>

<style lang="scss" scoped>
.form.campaign {
  .checkboxes {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    justify-content: left;
    label {
      margin-left: unset;
    }
  }
}
</style>
